import * as React from "react";

import { Locale, Vendor } from "@shared/types";
import { VendorContext } from "./VendorProvider";

export interface CurrentVendorProps {
  currentVendor: Vendor;
  currentLocale: Locale;
}
const withCurrentVendor = <
  WrappedProps extends Partial<CurrentVendorProps>,
  ComponentProps = Omit<WrappedProps, "currentVendor" | "currentLocal">,
>(
  WrappedComponent: React.ComponentType<WrappedProps>
) => {
  const Component = (props: ComponentProps) => (
    <VendorContext.Consumer>
      {([{ currentVendor, currentLocale }]) => {
        const componentProps = { ...props, currentVendor, currentLocale } as unknown as WrappedProps;
        return <WrappedComponent {...componentProps} />;
      }}
    </VendorContext.Consumer>
  );
  Component.displayName = WrappedComponent.displayName;
  return Component;
};

export default withCurrentVendor;
